import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastProvider } from './contexts/ToastContext';
import UserView from './components/UserView';
import AdminView from './components/AdminView';
import './App.css';

function App() {
  return (
    <Router>
      <ToastProvider>
        <div className="App">
          <Routes>
            <Route path="/" element={<UserView />} />
            <Route path="/adminForever" element={<AdminView />} />
          </Routes>
        </div>
      </ToastProvider>
    </Router>
  );
}

export default App;